import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import { MissionsCreatePage } from './missions-create'
import { MissionsListPage } from './missions-list'
import { MissionsUpdatePage } from './missions-update'

export const missionTypeRoutes: Route[] = [
  {
    path: Paths.MISSION_TYPE_LIST_PAGE,
    element: <MissionsListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.MISSION_TYPE_CREATE_PAGE,
    element: <MissionsCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.MISSION_TYPE_UPDATE_PAGE,
    element: <MissionsUpdatePage />,
    roles: [RoleEnum.ADMIN]
  }
]
